import {
	Link, useRouteMatch, useLocation
}from 'react-router-dom'
import {
	Menu, Button, Form, Layout, Row, Col
}from 'antd'
import 'antd/lib/grid/style/index.css'
import 'antd/lib/badge/style/index.css'

import React, {
	useEffect
}from 'react'
import {
	useDispatch,
	useSelector
}from 'react-redux'
import i18n from './localization'
import './style.css'
import {
	reContactAction
}from "../../containers/Contacts/actions"
const {
	Footer
} = Layout

const linkFooterItems = [
	'/news',
	'/contacts',
	'/help'

	// '/nsi'
]
const logoTextH = {
	0 : "Сістэма зваротаў",
	1 : "Система обращений"
}
export default () => {
	const dispatch = useDispatch()
	useEffect(() => {
		dispatch(reContactAction.getContact())
	}, [])
	const isRu = useSelector((state) => state.globalReducer.isRu)
	const contacts = useSelector((state) => state.reContactReducer.contact)
	return (
		<>
			<Footer className="footer">
				<nav>
					<Row className="fstRow">
						<Col
							className="col1"
							span={ 8 }
						>
							<Link to="/">
								<div>
									{ logoTextH[isRu] }
								</div>
							</Link>
						</Col>
						<Col
							className="col2"
							span={ 8 }
						>
							<div className="foot-nav">
								<Menu
									mode="inline"
									selectable={ false }
								>
									{ i18n.footerItems[isRu].map((item, index) => {
										return (
											<Menu.Item key={ index }>
												<Link
													style={ {
														color: 'white'
													} }
													to={ linkFooterItems[index] }
												>
													{ item }
												</Link>
											</Menu.Item>
										)
									}) }
								</Menu>
							</div>
						</Col>
						<Col
							className="col3"
							span={ 8 }
						>
							{ contacts ? (<>
								<Row className="email-row">
									<Col>
										<svg
											fill="none"
											height="16"
											viewBox="0 0 22 16"
											width="22"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M21.8 0.799988V15.2H0.200012V0.799988H21.8ZM1.70822 2.23999L11 7.20124L20.2918 2.23999H1.70822ZM20.45 13.76V3.76999L11 8.79874L1.55001 3.76999V13.76H20.45Z"
											/>
										</svg>
									</Col>
									<Col>
										<a href={ `mailto:${ contacts.mail }` }>
											{ contacts.mail }
										</a>
									</Col>
								</Row>
								{ contacts.phoneNumber ? (
									<Row>
										<Col>
											<svg
												fill="none"
												height="22"
												viewBox="0 0 22 22"
												width="22"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M17.1572 12.993C17.4667 12.993 17.7622 13.0493 18.0435 13.1617C18.3249 13.2742 18.5782 13.443 18.8033 13.668L21.1247 15.9882C21.3428 16.2062 21.5081 16.4558 21.6206 16.737C21.7332 17.0183 21.793 17.3171 21.8 17.6335C21.8 17.9429 21.7437 18.2382 21.6312 18.5194C21.5186 18.8006 21.3498 19.0538 21.1247 19.2788L20.977 19.4264C20.5971 19.8061 20.2489 20.1436 19.9323 20.4389C19.6158 20.7342 19.2851 20.9803 18.9404 21.1771C18.5958 21.374 18.2124 21.5287 17.7903 21.6412C17.3682 21.7537 16.8652 21.8064 16.2814 21.7994C15.402 21.7994 14.4981 21.6623 13.5695 21.3881C12.641 21.1139 11.7194 20.7342 10.8049 20.249C9.89044 19.7639 8.99001 19.1874 8.10365 18.5194C7.21729 17.8515 6.38369 17.1237 5.60285 16.3363C4.82201 15.5488 4.09744 14.7121 3.42916 13.8262C2.76087 12.9403 2.19107 12.0403 1.71975 11.1263C1.24843 10.2122 0.875597 9.29467 0.601248 8.37361C0.326899 7.45254 0.193241 6.56663 0.200276 5.71587C0.200276 5.13229 0.249518 4.63309 0.348003 4.21826C0.446487 3.80342 0.597731 3.42375 0.801734 3.07923C1.00574 2.7347 1.25195 2.40776 1.54037 2.0984C1.82879 1.78903 2.16645 1.44099 2.55335 1.05428L2.72218 0.885539C2.94025 0.667577 3.18998 0.498832 3.47136 0.379304C3.75275 0.259776 4.05172 0.200012 4.36828 0.200012C4.6778 0.200012 4.97325 0.259776 5.25463 0.379304C5.53602 0.498832 5.78926 0.667577 6.01437 0.885539L8.33579 3.20579C8.55386 3.42375 8.71918 3.67335 8.83173 3.95459C8.94428 4.23583 9.00408 4.53465 9.01111 4.85105C9.01111 5.16042 8.95835 5.43463 8.85283 5.67368C8.74731 5.91274 8.61717 6.13422 8.46241 6.33812C8.30765 6.54202 8.13882 6.72131 7.95592 6.87599C7.77302 7.03068 7.60067 7.18887 7.43888 7.35059C7.27708 7.5123 7.14694 7.66698 7.04846 7.81464C6.94997 7.96229 6.89721 8.13455 6.89018 8.33142C6.89018 8.5986 6.98515 8.82711 7.17508 9.01695L12.9892 14.8281C13.1791 15.0179 13.4077 15.1129 13.675 15.1129C13.8579 15.1129 14.0268 15.0601 14.1815 14.9547C14.3363 14.8492 14.4946 14.7191 14.6564 14.5644C14.8182 14.4098 14.9765 14.241 15.1312 14.0582C15.286 13.8754 15.4654 13.7031 15.6694 13.5414C15.8734 13.3797 16.0914 13.2496 16.3236 13.1512C16.5557 13.0528 16.8336 13 17.1572 12.993ZM16.2814 20.4494C16.7879 20.4494 17.2099 20.4037 17.5476 20.3123C17.8853 20.2209 18.1948 20.0838 18.4762 19.901C18.7575 19.7182 19.0249 19.4932 19.2781 19.226C19.5314 18.9588 19.8303 18.6565 20.175 18.319C20.365 18.1292 20.4599 17.9007 20.4599 17.6335C20.4599 17.5069 20.4107 17.3593 20.3122 17.1905C20.2137 17.0218 20.0801 16.839 19.9112 16.6421C19.7424 16.4452 19.563 16.2519 19.3731 16.0621C19.1831 15.8722 18.9862 15.6824 18.7822 15.4925C18.5782 15.3027 18.3988 15.1375 18.244 14.9969C18.0893 14.8562 17.9591 14.7332 17.8536 14.6277C17.6637 14.4379 17.4315 14.343 17.1572 14.343C16.9743 14.343 16.8054 14.3957 16.6507 14.5012C16.4959 14.6066 16.3412 14.7367 16.1864 14.8914C16.0316 15.0461 15.8734 15.2148 15.7116 15.3976C15.5498 15.5804 15.3669 15.7527 15.1629 15.9144C14.9589 16.0761 14.7408 16.2062 14.5086 16.3046C14.2765 16.4031 13.9986 16.4558 13.675 16.4628C13.3655 16.4628 13.0701 16.4066 12.7887 16.2941C12.5073 16.1816 12.2541 16.0128 12.029 15.7878L6.21486 9.97668C5.99679 9.75872 5.83147 9.50912 5.71892 9.22788C5.60637 8.94664 5.54657 8.64782 5.53954 8.33142C5.53954 8.02205 5.5923 7.74784 5.69782 7.50879C5.80333 7.26973 5.93347 7.04825 6.08824 6.84435C6.243 6.64045 6.41183 6.46116 6.59473 6.30648C6.77763 6.15179 6.94997 5.99008 7.11177 5.82133C7.27357 5.65259 7.40371 5.49791 7.50219 5.35729C7.60067 5.21666 7.65343 5.04792 7.66047 4.85105C7.66047 4.57684 7.5655 4.34481 7.37557 4.15498C7.28412 4.06357 7.16453 3.93701 7.0168 3.7753C6.86908 3.61359 6.70376 3.43429 6.52086 3.23742C6.33796 3.04056 6.14803 2.84369 5.95106 2.64682C5.75409 2.44995 5.55712 2.26714 5.36015 2.0984C5.16319 1.92965 4.9838 1.79958 4.82201 1.70817C4.66021 1.61677 4.50897 1.56404 4.36828 1.54997C4.10096 1.54997 3.87234 1.64489 3.6824 1.83473L2.78549 2.73119C2.52521 2.99134 2.3001 3.25852 2.11017 3.53273C1.92024 3.80694 1.77954 4.11279 1.68809 4.45028C1.59664 4.78777 1.5474 5.20963 1.54037 5.71587C1.54037 6.50335 1.66699 7.31543 1.92024 8.15213C2.17348 8.98882 2.52873 9.82552 2.98598 10.6622C3.44323 11.4989 3.98137 12.3215 4.60042 13.1301C5.21946 13.9387 5.89478 14.7086 6.62638 15.4398C7.35798 16.171 8.12827 16.839 8.93725 17.4437C9.74623 18.0483 10.5693 18.5757 11.4064 19.0256C12.2435 19.4756 13.0736 19.8237 13.8966 20.0698C14.7197 20.3158 15.5146 20.4424 16.2814 20.4494Z"
												/>
											</svg>
										</Col>
										<Col>
											<span className="multiline">
												{ contacts.phoneNumber }
											</span>
										</Col>
									</Row>
								) : null }
								<Row>
									<Col>
										<svg
											fill="none"
											height="24"
											viewBox="0 0 19 24"
											width="19"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path d="M9.58268 0C4.61704 0 0.574799 4.31698 0.574799 9.62013C0.574799 10.2239 0.626622 10.8327 0.734981 11.4264C0.739692 11.4616 0.758537 11.5673 0.796227 11.7484C0.932853 12.3975 1.13544 13.0365 1.39926 13.6453C2.36978 16.0855 4.50397 19.834 9.18694 23.8491C9.30472 23.9497 9.44606 24 9.5874 24C9.72873 24 9.87007 23.9497 9.98785 23.8491C14.6661 19.834 16.805 16.0855 17.7755 13.6453C18.0394 13.0365 18.2419 12.4025 18.3786 11.7484C18.4163 11.5673 18.4351 11.4616 18.4398 11.4264C18.5435 10.8327 18.6 10.2239 18.6 9.62013C18.5906 4.31698 14.5483 0 9.58268 0ZM17.1772 11.1899C17.1772 11.2 17.1725 11.2101 17.1725 11.2201C17.1678 11.2453 17.1536 11.3208 17.1301 11.4365C17.1301 11.4415 17.1301 11.4415 17.1301 11.4465C17.0123 12.0101 16.838 12.5585 16.6071 13.0868C16.6024 13.0918 16.6024 13.1019 16.5977 13.1069C15.7167 15.3358 13.7851 18.7371 9.58268 22.4453C5.38026 18.7371 3.44865 15.3358 2.56765 13.1069C2.56294 13.1019 2.56294 13.0918 2.55823 13.0868C2.33209 12.5635 2.15777 12.0101 2.03528 11.4465C2.03528 11.4415 2.03528 11.4415 2.03528 11.4365C2.00701 11.3208 1.99759 11.2453 1.99288 11.2201C1.99288 11.2101 1.98817 11.2 1.98817 11.1849C1.89394 10.6667 1.84683 10.1434 1.84683 9.61509C1.84683 5.06164 5.31901 1.35346 9.58268 1.35346C13.8464 1.35346 17.3185 5.06164 17.3185 9.61509C17.3185 10.1484 17.2714 10.6767 17.1772 11.1899Z" />
											<path d="M9.58266 3.61755C6.43084 3.61755 3.86322 6.35969 3.86322 9.72573C3.86322 13.0918 6.43084 15.8339 9.58266 15.8339C12.7345 15.8339 15.3021 13.0918 15.3021 9.72573C15.3021 6.35969 12.7345 3.61755 9.58266 3.61755ZM9.58266 14.4754C7.12811 14.4754 5.13525 12.3421 5.13525 9.72573C5.13525 7.10938 7.13282 4.97604 9.58266 4.97604C12.0325 4.97604 14.0301 7.10938 14.0301 9.72573C14.0301 12.3421 12.0372 14.4754 9.58266 14.4754Z" />
										</svg>
									</Col>
									<Col>
										<span>
											{ contacts.address }
										</span>
									</Col>
								</Row>
							</>) : null }

						</Col>
					</Row>
				</nav>

				<Row
					className="scRow"
					justify="center"
				>
					<a
						className="link-ipps"
						href="https://ddc.by/"
					>
						{ i18n.copyrightFooter[isRu] }
					</a>
				</Row>
			</Footer>
		</>
	)
}

